import { Injectable } from '@angular/core';
import { HhsgSharedStuderDivision } from '../../models/sgportal-data-api-models/division.model';
import { HhsgSharedStuderEmployee } from '../../models/sgportal-data-api-models/employee.model';
import { HhsgSharedConfigService } from '../config.service';
import { HhsgSharedHttpService } from '../http.service';

@Injectable()
export class HhsgSharedStuderDivisionService {
	private readonly _controllerName: string = 'Division';
    private readonly _sgPortalApiServer: string;

	constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) {
        this._sgPortalApiServer = _configService.appSettings.sgPortalApiServer;
    }

	public getDivisionsForOrganization(organizationId: number): Promise<HhsgSharedStuderDivision[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderDivision[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetDivisionsForOrganization/${organizationId}`);
	}

	public getDivisionsWithEmployeeCount(organizationId: number): Promise<HhsgSharedStuderDivision[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderDivision[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetDivisionsWithEmployeeCount/${organizationId}`);
	}

	public getDivision(divisionId: number, organizationId: number): Promise<HhsgSharedStuderDivision> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderDivision>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetDivision/${divisionId}/${organizationId}`);
	}

	public getEmployeeDeptAndJobTitleForDivision(divisionId: number, organizationId: number): Promise<HhsgSharedStuderEmployee[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderEmployee[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetEmployeeDeptAndJobTitleForDivision/${divisionId}/${organizationId}`);
	}

	public saveDivision(divisionModel: HhsgSharedStuderDivision): Promise<string> {
		return this._httpService.doPostRequestAsync<any, string>(this._sgPortalApiServer, this._controllerName, 'SaveDivision', divisionModel);
	}

	public deleteDivision(divisionModel: HhsgSharedStuderDivision): Promise<void> {
		return this._httpService.doPostRequestAsync<any, void>(this._sgPortalApiServer, this._controllerName, 'deleteDivision', divisionModel);
	}
}
